module.exports = __webpack_public_path__ + "static/media/avatar_koala.ab406889.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_koala.png
// module id = 386
// module chunks = 0